// Panel de seguimiento del investigador (grupos de participantes / familias).
export const suivi = {
  suivi_tab_label: "Seguimiento",
  suivi_caption_todo: "{{count}} por tratar",
  suivi_caption_uptodate: "{{count}} al día",
  suivi_caption_all_done: "Todo al día · {{count}} expedientes",
  suivi_search_placeholder: "N.º de expediente…",
  suivi_search_no_match: "Ningún expediente coincide con «{{query}}»",
  suivi_group_todo_title: "Por tratar",
  suivi_group_uptodate_title: "Al día",
  suivi_up_to_date_row: "Nada pendiente",
  suivi_empty: "Todavía no hay expedientes",
  suivi_dossier: "Expediente {{code}}",
  suivi_family: "Familia",
  suivi_group_title: "Expediente",
  suivi_member_generic: "Participante",
  suivi_action_fill: "1 cuestionario por rellenar",
  suivi_action_fill_plural: "{{count}} cuestionarios por rellenar",
  suivi_action_remind: "Por recordar",
  suivi_action_remind_role: "Recordar · {{role}}",
  suivi_members: "Miembros",
  suivi_to_fill: "Para rellenar por usted",
  suivi_parents_side: "Lado participantes",
  suivi_history: "Historial",
  suivi_history_done: "{{count}} completados",
  suivi_history_missed: "{{count}} perdidos",
  suivi_done_on: "Hecho el {{date}}",
  suivi_missed_on: "Ventana expirada · {{date}}",
  suivi_answered_by: "Respondido por {{who}}",
  suivi_answered_by_you: "usted",
  suivi_to_answer_by: "A rellenar por {{who}}",
  suivi_questionnaire: "Cuestionario",
  suivi_fill: "Rellenar",
  suivi_continue_progress: "Continuar {{answered}}/{{total}}",
  suivi_filled_by_colleague: "Rellenado por un colega",
  suivi_status_not_started: "Sin empezar",
  suivi_status_in_progress: "En curso {{answered}}/{{total}}",
  suivi_call: "Llamar",
  suivi_copy_number: "Copiar el número",
  suivi_contact: "Contactar",
  suivi_copy_email: "Copiar el correo",
  suivi_email_copied: "Correo copiado",
  suivi_copied: "Número copiado",
  suivi_during_call: "Durante la llamada",
  suivi_minutes: "≈ {{count}} min",
  suivi_mark_reminded: "Marcar como recordado hoy",
  suivi_reminded_on: "Recordado el {{date}}",
  suivi_empty_group: "Nada pendiente para este expediente",
  suivi_next_window_fill: "Para rellenar por usted: {{label}} — se abre el {{date}}",
  suivi_next_window_subject: "{{role}}: {{label}} — se abre el {{date}}",
  suivi_home_next_window: "Próxima ventana: el {{date}} ({{group}})",
  suivi_due_today: "Hoy",
  suivi_due_tomorrow: "Mañana",
  suivi_due_in_days: "Quedan {{count}} días",
  suivi_due_past: "Expirado",
  // « Añadir un expediente » — gestión de expedientes por el investigador.
  suivi_new_dossier_button: "Nuevo expediente",
  suivi_new_dossier_title: "Nuevo expediente",
  suivi_new_dossier_description:
    "Introduzca el número de expediente y la composición de la familia. Los padres crearán luego su cuenta con este mismo número.",
  suivi_new_dossier_create: "Crear expediente",
  suivi_dossier_numero_label: "Número de expediente",
  suivi_dossier_numero_required: "El número de expediente es obligatorio",
  suivi_dossier_members_required: "Añada al menos un miembro",
  suivi_dossier_exists: "Este expediente ya existe",
  suivi_add_member_button: "Añadir un miembro",
  suivi_add_member_title: "Añadir un miembro",
  suivi_add_member_role_required: "Elija un rol",
  suivi_add_member_confirm: "Añadir",
  suivi_add_member_done: "Miembro añadido",
  suivi_remove_member_title: "Retirar este miembro",
  suivi_remove_member_text:
    "¿Retirar {{role}} de este expediente? Solo es posible mientras no se hayan introducido datos.",
  suivi_remove_member_confirm: "Retirar",
  suivi_remove_member_done: "Miembro retirado",
  suivi_remove_member_blocked:
    "Este miembro ya tiene datos y no puede retirarse.",

  suivi_member_actions: "Acciones",
  suivi_exit_member_title: "Salida del estudio",
  suivi_exit_member_text:
    "{{name}} dejará de participar en el estudio. Los datos ya recogidos se conservan; no se creará ningún cuestionario nuevo ni se enviarán recordatorios.",
  suivi_exit_dossier_title: "Salida del estudio del expediente",
  suivi_exit_dossier_text:
    "Todos los miembros del expediente {{name}} saldrán del estudio, incluidos los vinculados a otro centro. Los datos ya recogidos se conservan.",
  suivi_exit_reason_label: "Motivo",
  suivi_exit_reason_withdrawal: "Retirada",
  suivi_exit_reason_screen_failure: "No elegible",
  suivi_exit_reason_lost: "Pérdida de seguimiento",
  suivi_exit_reason_error: "Error de inclusión",
  suivi_exit_reason_other: "Otro",
  suivi_exit_note_label: "Detalle (opcional)",
  suivi_exit_data_label: "Datos ya recogidos",
  suivi_exit_data_keep: "Conservar",
  suivi_exit_data_drop: "Dejar de usar",
  suivi_exit_data_drop_warning:
    "Los datos de esta persona se retirarán de las exportaciones y dejarán de ser visibles. Esta acción es irreversible.",
  suivi_exit_confirm: "Confirmar la salida",
  suivi_exit_member_done: "Salida registrada",
  suivi_exit_dossier_done: "Expediente retirado",
  suivi_exit_dossier_button: "Salida del estudio del expediente",
  suivi_exited_tag: "Salida del estudio",
  suivi_exited_tag_reason: "Salida del estudio · {{reason}}",

  suivi_death_title: "Registrar un fallecimiento",
  suivi_death_text:
    "Registrar el fallecimiento de {{name}}. Los datos se conservan y el resto del expediente continúa su seguimiento.",
  suivi_death_date_label: "Fecha del fallecimiento (opcional)",
  suivi_death_confirm: "Registrar",
  suivi_death_done: "Fallecimiento registrado",
  suivi_death_clear_title: "Anular el fallecimiento registrado",
  suivi_death_clear_done: "Registro anulado",
  suivi_deceased_tag: "Fallecimiento",

  suivi_access_link_title: "Enviar el enlace de acceso",
  suivi_access_link_resend_title: "Reenviar el enlace de acceso",
  suivi_access_link_text:
    "{{name}} recibirá un enlace para crear su cuenta y acceder a sus cuestionarios.",
  suivi_access_link_email_label: "Correo electrónico",
  suivi_access_link_confirm: "Enviar",
  suivi_access_link_done: "Enlace de acceso enviado",
  suivi_access_link_unavailable:
    "No se puede enviar el enlace: no hay contacto registrado o no hay ninguna invitación configurada para este perfil.",
  suivi_invited_on: "Invitado el {{date}}",

  // « Fechas de referencia » — reglas del expediente que derivan la fecha ancla de un miembro (modo familia).
  suivi_refdates: "Fechas de referencia",
  suivi_refdate_resolved: "Fecha retenida: {{date}}",
  suivi_refdate_waiting: "En espera — {{done}} de {{total}}",
  suivi_refdate_deceased: "(fallecidos: {{n}})",
  suivi_refdate_missing: "Falta: {{who}}",
  suivi_refdate_missing_hidden: "{{n}} fuera de su centro",
  suivi_refdate_no_source: "Sin fecha de origen",
  suivi_refdate_no_source_death: "Sin fecha de origen — fallecimiento",
  suivi_refdate_unconfigured:
    "Regla por completar por el equipo de investigación",
  suivi_refdate_member_missing: "Falta la fecha «{{label}}»",

  // « Consentimientos » — estado de las opciones por miembro, ausencias del expediente, resumen de condiciones.
  suivi_consents: "Consentimientos",
  suivi_consent_granted: "Otorgado",
  suivi_consent_refused: "Rechazado",
  suivi_consent_to_collect: "Por recoger",
  suivi_consent_source_in_app: "aplicación",
  suivi_consent_source_paper: "papel",
  suivi_consent_source_phone: "teléfono",
  suivi_consent_source_other: "otro",
  suivi_consent_to_collect_tag: "Consentimiento por recoger",
  suivi_action_collect_consent: "Consentimiento por recoger",
  suivi_consent_action: "Registrar los consentimientos",
  suivi_consent_sheet_title: "Registrar los consentimientos",
  suivi_consent_sheet_text:
    "{{name}} — indique lo que se ha recogido (formulario en papel, teléfono).",
  suivi_consent_not_seen: "Progenitor no visto",
  suivi_consent_yes: "Sí",
  suivi_consent_no: "No",
  suivi_consent_unknown: "No recogido",
  suivi_consent_source_label: "Recogido por",
  suivi_consent_source_paper_choice: "Formulario en papel",
  suivi_consent_source_phone_choice: "Teléfono",
  suivi_consent_source_other_choice: "Otro",
  suivi_consent_date_label: "Fecha de recogida",
  suivi_consent_note_label: "Observación (opcional)",
  suivi_consent_refusal_warning:
    "Un rechazo bloquea los cuestionarios afectados; la salida del expediente queda por decidir.",
  suivi_consent_confirm: "Guardar",
  suivi_consent_done: "Consentimientos registrados",
  suivi_consent_conflict:
    "Otra persona acaba de modificar estos consentimientos. Actualice y vuelva a intentarlo.",
  suivi_consent_gate_title: "Cuestionarios {{role}}",
  suivi_consent_gate_waiting: "En espera de {{roles}}",
  suivi_consent_gate_blocked: "Bloqueado — rechazo de {{who}}",
  suivi_consent_gate_satisfied: "Condiciones cumplidas",
  suivi_consent_opposition_exit: "Oposición — retirar el expediente",
  suivi_absence_declared_line:
    "Ningún/a {{role}} en este expediente — declarado ({{source}}, {{date}})",
  suivi_absence_declare_short: "Declarar ausente",
  suivi_absence_prompt: "¿Ningún(a) {{role}} en este expediente?",
  suivi_absence_declare: "Ningún/a {{role}} en este expediente",
  suivi_absence_declare_text:
    "¿Declarar que no hay {{role}} en este expediente? Los cuestionarios dejarán de esperar su consentimiento y la invitación dejará de ofrecerse. La declaración se levanta automáticamente si un/a {{role}} se inscribe o da su consentimiento.",
  suivi_absence_declare_confirm: "Declarar",
  suivi_absence_clear: "Anular la declaración",
  suivi_absence_declared_done: "Ausencia declarada",
  suivi_absence_cleared_done: "Declaración anulada",
  suivi_absence_has_member: "Ya hay un/a {{role}} en este expediente.",
  suivi_exit_reason_opposition: "Oposición al tratamiento de los datos",

  invite_relative_menu_title: "Invitar a {{role}}",
  invite_relative_menu_action: "Invitar",
  invite_relative_title: "Invitar",
  invite_relative_text:
    "Recibirá un enlace para unirse a su expediente, leer la nota informativa y crear su cuenta.",
  invite_relative_unavailable: "No hay ninguna invitación disponible por el momento.",
  invite_relative_firstname: "Nombre",
  invite_relative_lastname: "Apellidos",
  invite_relative_email: "Correo electrónico",
  invite_relative_role_required: "Elija a quién desea invitar.",
  invite_relative_fields_required: "Complete todos los campos.",
  invite_relative_confirm: "Enviar la invitación",
  invite_relative_done: "Invitación enviada",
};
